export const SnackbarConfig = {
    duration: 10000
};
